import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import Group from "../../../ServicosAcolhimento/Visualizar/Group";
import { useEffect, useState, useCallback } from "react";
import CriancaService from "../../../../../main/services/CriancaService";

import LoadingSpinner from "../../../../components/LoadingSpinner";
import { useHistory } from "react-router";
import { useFormikContext } from "formik";
import { IrmaoTable } from "../../ReferenciaFamiliar/Irmaos/Table";
import { format } from "date-fns";

export const VisualizarPageApadrinhamento = ({
  id,
  setIsTrueVisualizar,
  setInitialValues,
  url,
  idAba,
  idTipoPendencia,
}) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const { setFieldValue } = useFormikContext();

  function dataInvertFormat(data) {
    if (!data) return null;
    const date = new Date(data);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate;
  }
  const getPendentes = useCallback(() => {
    CriancaService.listarPendentes(id)
      .then((res) => {
        let tempObj = {};
        res.data.forEach((item) => {
          const tempItem = item.split(":");
          tempObj[tempItem[0]] = Number(tempItem[1]);
        });

        if (tempObj.apadrinhamento === 0) {
          setLoading(false);
          setIsTrueVisualizar(false);
          setFieldValue("incluidoProgApadrinh", "");
          setFieldValue("sendoApadrinhado", "");
        }
      })
      .catch((error) => console.log(error));
  }, [id, setIsTrueVisualizar, setFieldValue]);

  useEffect(() => {
    setLoading(true);
    CriancaService.getValidarCriancaApadrinhamento(id);
    CriancaService.getCriancaApadrinhamento(id)
      .then((res) => {
        if (res.data) {
          const pessoaPrograma = res?.data?.pessoasProgramaApadrinhamento?.map(
            (pessoa) => ({
              ...pessoa,
              tipoPessoaProgApadrinha:
                pessoa.tipoPessoaProgApadrinha === "P"
                  ? { idTipo: 1, descricaoTipo: "Padrinho (Programa)" }
                  : pessoa.tipoPessoaProgApadrinha === "M"
                  ? { idTipo: 2, descricaoTipo: "Madrinha (Programa)" }
                  : "",
              dataInicioApadrinhamento: pessoa?.dataInicioApadrinhamento
                ? dataInvertFormat(pessoa?.dataInicioApadrinhamento)
                : "",

              dataFimApadrinhamento: pessoa?.dataFimApadrinhamento
                ? dataInvertFormat(pessoa?.dataFimApadrinhamento)
                : "",
            })
          );

          setInitialValues({
            id: res?.data?.id,
            pessoasProgramaApadrinhamento: pessoaPrograma,
            incluidoProgApadrinh: res?.data?.incluidoProgApadrinh,
            sendoApadrinhado: res?.data?.sendoApadrinhado,
          });

          setFieldValue("pessoasProgramaApadrinhamento", pessoaPrograma);

          setData(res.data);

          if (url.includes("editar")) {
            setIsTrueVisualizar(false);
          } else {
            setIsTrueVisualizar(true);
          }
        } else {
          setIsTrueVisualizar(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);

        let path = `/crianca/visualizar-apadrinhamento/${id}`;
        path +=
          idAba && idTipoPendencia
            ? `?idAba=${idAba}&idTipoPendencia=${idTipoPendencia}`
            : "";

        history.push(path);
        setIsTrueVisualizar(false);
        setLoading(true);
        setInitialValues({
          pessoasProgramaApadrinhamento: [
            {
              tipoPessoaProgApadrinha: "",
              nomePessoaApadrinhamento: "",
              id: 0,
              dataInicioApadrinhamento: "",
              dataFimApadrinhamento: "",
              informacaoComplementar: "",
            },
          ],

          incluidoProgApadrinh: "",
          sendoApadrinhado: "",
        });
      })
      .finally(() => {
        getPendentes();
      });
  }, [
    id,
    url,
    setInitialValues,
    history,
    setIsTrueVisualizar,
    setFieldValue,
    getPendentes,
    idAba,
    idTipoPendencia,
  ]);

  const columns = [
    {
      Header: "Nome",
      accessor: "nomePessoaApadrinhamento",
      Cell: (props) => {
        const nomePessoaApadrinhamento = props?.value;

        return (
          <span>
            {nomePessoaApadrinhamento ? nomePessoaApadrinhamento : ""}
          </span>
        );
      },
    },
    {
      Header: "Tipo",
      accessor: "tipoPessoaProgApadrinha",
      Cell: (props) => {
        const tipo = props?.value;

        return (
          <Text whiteSpace={"nowrap"}>
            {tipo === "P"
              ? "Padrinho (Programa)"
              : tipo === "M"
              ? "Madrinha (Programa)"
              : ""}
          </Text>
        );
      },
    },
    {
      Header: "Data Início",
      accessor: "dataInicioApadrinhamento",
      Cell: (props) => {
        const dataInicioApadrinhamento = props?.value;

        return (
          <span>
            {dataInicioApadrinhamento
              ? format(new Date(dataInicioApadrinhamento), "dd/MM/yyyy")
              : ""}
          </span>
        );
      },
    },
    {
      Header: "Data Fim",
      accessor: "dataFimApadrinhamento",
      Cell: (props) => {
        const dataFimApadrinhamento = props?.value;

        return (
          <span>
            {dataFimApadrinhamento
              ? format(new Date(dataFimApadrinhamento), "dd/MM/yyyy")
              : ""}
          </span>
        );
      },
    },

    {
      Header: "Informações Complementares",
      accessor: "informacaoComplementar",
      Cell: (props) => {
        const informacaoComplementar = props?.value;

        return (
          <span>{informacaoComplementar ? informacaoComplementar : ""}</span>
        );
      },
    },
  ];

  return !loading ? (
    <Group title="Programa de Apadrinhamento">
      <Flex mt="17px" direction={"column"} gap="18px">
        <Box>
          <Text as="b">Está Incluída no Programa de Apadrinhamento? </Text>
          <Text>
            {data.incluidoProgApadrinh === "S"
              ? "Sim"
              : data.incluidoProgApadrinh === "N"
              ? "Não"
              : "Sem Informação"}
          </Text>
        </Box>

        {data.incluidoProgApadrinh === "S" && (
          <Box>
            <Text as="b">Está Sendo Apadrinhado? </Text>
            <Text>
              {data.sendoApadrinhado === "S"
                ? "Sim"
                : data.sendoApadrinhado === "N"
                ? "Não"
                : "Sem Informação"}
            </Text>
          </Box>
        )}

        {data.sendoApadrinhado === "S" ? (
          <>
            {data?.pessoasProgramaApadrinhamento &&
              data?.pessoasProgramaApadrinhamento.length > 0 && (
                <IrmaoTable
                  mt={"0px"}
                  columns={columns}
                  data={data.pessoasProgramaApadrinhamento}
                  filiacoes={data}
                  idCrianca={id}
                  entidade="apadrinhamento"
                  disableHeaderOptionsOpcoes={true}
                />
              )}
          </>
        ) : (
          ""
        )}
      </Flex>
    </Group>
  ) : (
    <Box mt={4}>
      <LoadingSpinner />
    </Box>
  );
};
